import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import profileImg from "../assets/logo.png";
import ViewAllVendors from "./ViewAllVendors";
import "../styles/ViewAllInvoiceSecurity.css";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "../../src/components/DashboardLayout";


const ViewAllInvoicesSecurity = () => {
    const [invoices, setInvoices] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showCard, setShowCard] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = React.useState({ approvalStatus: "" });
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("details"); 
    const [comment, setComment] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [invoiceDetails, setInvoiceDetails] = React.useState({
        ApprovalStatus: "",
        Comments: "",
    });
    const [invoiceInfo, setInvoiceInfo] = useState(null);
    const [info, setinfo] = useState(null);
    const [VendorInfo, setVendorInfo] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [subTab, setSubTab] = useState("details");
    //const [isEditing, setIsEditing] = useState(false);
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [commentError, setCommentError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [supplierTypeError, setSupplierTypeError] = useState("");
    const [departmentHeadError, setDepartmentHeadError] = useState("");
    const [emailApprovalError, setemailApprovalError] = useState("");
    const [poError, setpoError] = useState("");
    const [prError, setprError] = useState("");
    const [quotationError, setquotationError] = useState("");
    const [supplierNameError, setSupplierNameError] = useState("");
    const [invoiceFileError, setInvoiceFileError] = useState("");
    const [grnNoError, setGrnNoError] = useState("");
    const [grnDateError, setGrnDateError] = useState("");
    const [invoiceNoError, setInvoiceNoError] = useState("");
    const [invoiceDateError, setInvoiceDateError] = useState("");
    const [poNoError, setPoNoError] = useState("");
    const [dcNoError, setDcNoError] = useState("");
    const [receivedByError, setReceivedByError] = useState("");
    const [preparedByError, setPreparedByError] = useState("");
    const [collectedByError, setCollectedByError] = useState("");
    const [handoverToError, setHandoverToError] = useState("");
    const [goodsListError, setGoodsListError] = useState("");

    <ViewAllVendors
        activeTab={activeTab}
        subTab={subTab}
        setSubTab={setSubTab}
        isEditing={isEditing}
        selectedVendor={selectedInvoice} // can rename internally if needed
        //handleInputChange={handleInputChange}
        setIsEditing={setIsEditing}
    />

    const updateGoodsList = (index, key, value) => {
        const updatedGoodsList = [...(selectedInvoice.goodsList || [])];
        updatedGoodsList[index] = {
            ...updatedGoodsList[index],
            [key]: value
        };
        setSelectedInvoice({
            ...selectedInvoice,
            goodsList: updatedGoodsList
        });
    };

    

    const handleReviewClick = async (index) => {
        const selected = invoices[index];
        setSelectedInvoice(selected);
        setShowModal(true);
        setActiveTab("details");

        // Fetch vendor info using the ID from selected invoice
        try {
            const res = await axios.get(`/api/vendordetails/details/${selected.id}`);
            if (res.data && res.data.length > 0) {
                setVendorInfo(res.data[0]); // assuming data is returned in an array
            } else {
                setVendorInfo(null);
            }            
        } catch (error) {
            console.error("Error fetching vendor info", error);
            setVendorInfo(null);
        }
        try {
            const invoiceRes = await axios.get(`/api/invoices/get-details/${selected.id}`);
            if (invoiceRes.data && invoiceRes.data.grnItems) {
                const data = invoiceRes.data;
                const normalizedInvoiceDetails = {
                    ...data,
                    Id: data.Id || data.ID || 0,
                };

                const transformedGoodsList = normalizedInvoiceDetails.grnItems.map(item => ({
                    description: item.itemName || "",     
                    quantity: item.receivedQty || 0,      
                    unit: "",                       
                    remarks: item.remarks || ""            
                }));

                setInvoiceDetails(normalizedInvoiceDetails);

                const downloadUrl = `/api/invoices/download-document/${selected.id}`;
                setSelectedInvoice((prev) => ({
                    ...prev,
                    ...normalizedInvoiceDetails,
                    invoiceDate: normalizedInvoiceDetails.invoiceDate,
                    grnDate: normalizedInvoiceDetails.grnDate,
                    goodsList: transformedGoodsList,
                    InvoiceDownloadUrl: downloadUrl
                }));
            } else {
                setInvoiceDetails(null);
            }
        } catch (error) {
            console.error("Error fetching invoice details", error);
            setInvoiceDetails(null);
        }
    };


    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };
    const handleSort = (column) => {
        const sortedInvoices = [...invoices].sort((a, b) => {
            let valueA, valueB;

            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }

            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });

        setInvoices(sortedInvoices);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };
    const invoicesPerPage = 6;

    useEffect(() => {
        const dark = localStorage.getItem("darkMode") === "true";
        document.body.classList.toggle("dark-mode", dark);
    }, []);

    useEffect(() => {
        axios.get("/api/invoices/list")
            .then(res => {
                setInvoices(res.data);
            })
            .catch(err => {
                console.error("Error fetching invoices", err);
            });
    }, []);

    const [historyData, setHistoryData] = useState([]);

    //useEffect(() => {
    //    if (selectedInvoice?.id) {
    //        axios
    //            .get(`/api/invoices/approval-history/${selectedInvoice.id}`)
    //            .then((res) => {
    //                setHistoryData(res.data);
    //            })
    //            .catch((err) => {
    //                console.error("Error fetching invoice approval history:", err);
    //                setHistoryData([]);
    //            });
    //    }
    //}, [activeTab, selectedInvoice]);

    useEffect(() => {
        if (selectedInvoice?.ID) {
            axios
                .get(`/api/invoices/approval-history/${selectedInvoice.ID}`)
                .then((res) => {
                    setHistoryData(res.data);
                })
                .catch((err) => {
                    console.error("Error fetching invoice approval history:", err);
                    setHistoryData([]);
                });
        }
    }, [activeTab, selectedInvoice]);


    useEffect(() => {
        axios
            .get(`/api/invoices/info/${selectedInvoice?.invoiceNo}`)
            .then((res) => {
                setInvoiceInfo(res.data);
            })
            .catch((err) => {
                console.error("Error fetching invoice info:", err);
                setInvoiceInfo(null);
            });
    }, [activeTab, selectedInvoice]);

    const totalPages = Math.ceil(invoices.length / invoicesPerPage);
    const startIndex = (currentPage - 1) * invoicesPerPage;
    const currentInvoices = invoices.slice(startIndex, startIndex + invoicesPerPage);

    const handlePageChange = (action) => {
        if (action === "first") setCurrentPage(1);
        else if (action === "prev" && currentPage > 1) setCurrentPage(prev => prev - 1);
        else if (action === "next" && currentPage < totalPages) setCurrentPage(prev => prev + 1);
        else if (action === "last") setCurrentPage(totalPages);
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: files[0] || null, 
        }));
    };
   

    const handleSaveStatus = async () => {
        try {
            if (!selectedInvoice.approvalStatus) {
                alert("Please select an approval status before saving.");
                return;
            }
            if (!invoiceDetails.Comments || invoiceDetails.Comments.trim() === "") {
                alert("Please enter comments.");
                return;
            }
            const payload = {
                ID: selectedInvoice?.id,
                ApprovalStatus: selectedInvoice.approvalStatus,
                Comments: selectedInvoice.comments,
                PreparedBy: selectedInvoice.preparedBy,
                ReceivedBy: selectedInvoice.receivedBy,
                CollectedBy: selectedInvoice.collectedBy,
                HandoverTo: selectedInvoice.handoverTo,
                GRNNo: selectedInvoice.grnNo,
                GRNDate: selectedInvoice.grnDate,
                DeliveryChallanNumber: selectedInvoice.DeliveryChallanNumber,
                GRNItems: selectedInvoice.GRNItems,
            };

            const response = await fetch("/api/invoices/save-review", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorText = await response.text();
                alert("Failed to save: " + errorText);
                return;
            }
            alert("Review saved successfully.");
            setShowModal(false);           

        } catch (error) {
            console.error("Error saving invoice review:", error);
            alert("An unexpected error occurred while saving.");
        }
    };

    const [formData, setFormData] = useState({
        AgreementDocument: "",
        EmailApproval: "",
        PO: "",
        Quotation1: "",
        Quotation2: "",
        PR: "",
        Invoice: "",
        ComparisonQuotes: ""
    });

    return (
        <DashboardLayout>
        <div className="invoice-container">
                    <h2 className="invoice-title">Invoice Approval Details</h2>

                    <table className="invoice-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Company Name</th>
                                <th>Invoice Type</th>
                                <th>Invoice Number</th>
                                <th>Total Value</th>
                                <th>Create Date</th>
                                <th onClick={() => handleSort("approvalStatus")} style={{ cursor: "pointer" }}>
                                    Approval Status {sortBy === "approvalStatus"
                                        ? (sortOrder === "asc" ? "▲" : "▼")
                                        : "⇅"}
                                </th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentInvoices.map((invoice, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{invoice.nameOfCompany}</td>
                                    <td>{invoice.invoiceType}</td>
                                    <td>{invoice.invoiceNo}</td>
                                    <td>{invoice.totalValue.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                    <td>{invoice.createdDate}</td>
                                    <td>{invoice.approvalStatus}</td>
                                    <td>
                                        <button className="review-btn" onClick={() => handleReviewClick(index)}>
                                            Review
                                        </button>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="pagination">
                        <button onClick={() => handlePageChange("first")} disabled={currentPage === 1}>First</button>
                        <button onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>Previous</button>
                        <span className="page-info">Page {currentPage} of {totalPages}</span>
                        <button onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>Next</button>
                        <button onClick={() => handlePageChange("last")} disabled={currentPage === totalPages}>Last</button>
                    </div>
                </div>
                <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered>
                    <ModalHeader toggle={() => setShowModal(false)}>Invoice Details</ModalHeader>
                    <div className="tabs1">
                        {/*<span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Vendor Info</span>*/}
                        {/*<span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Invoice Approval History</span>*/}
                        {/*<span className={activeTab === "infoInvoice" ? "active-tab" : ""} onClick={() => setActiveTab("infoInvoice")}>Invoice Info</span>*/}
                        <span style={{ display: "none" }}>Vendor Info</span>
                        <span style={{ display: "none" }}>Invoice Approval History</span>
                        <span style={{ display: "none" }}>Invoice Info</span>
                        <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Approve/Reject</span>

                    </div>
                    <ModalBody>
                        {(activeTab === "details" || activeTab === "info" || activeTab === "history" || activeTab === "infoInvoice") && (
                            <>
                                <Table bordered className="info-table1">
                                    <colgroup>
                                        <col style={{ width: '20%' }} />
                                        <col style={{ width: '30%' }} />
                                        <col style={{ width: '20%' }} />
                                        <col style={{ width: '30%' }} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th><strong>Name of Company:</strong></th>
                                            <td colSpan={3}>{selectedInvoice?.nameOfCompany || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <th><strong>Supplier Name:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="text"
                                                    value={selectedInvoice?.supplierName || ""}
                                                    onChange={(e) => setSelectedInvoice({ ...selectedInvoice, supplierName: e.target.value })}
                                                    placeholder="Enter"
                                                />
                                            </td>
                                            <th><strong>Invoice:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                {selectedInvoice?.InvoiceDownloadUrl && (
                                                    <a href={selectedInvoice.InvoiceDownloadUrl} target="_blank" rel="noopener noreferrer">
                                                        {selectedInvoice.fileName || "View Invoice"}
                                                    </a>
                                                )}
                                            </td>
                                        </tr>

                                        <tr>
                                            <th><strong>GRN No:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="text"
                                                    value={selectedInvoice?.grnNo || ""}
                                                    onChange={(e) => setSelectedInvoice({ ...selectedInvoice, grnNo: e.target.value })}
                                                    placeholder="Enter"
                                                />
                                            </td>
                                            <th><strong>GRN Date:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="date"
                                                    value={selectedInvoice?.grnDate || ""}
                                                    onChange={(e) =>
                                                        setSelectedInvoice({ ...selectedInvoice, grnDate: e.target.value })
                                                    }
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <th><strong>Invoice No:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="text"
                                                    value={selectedInvoice?.invoiceNo || ""}
                                                    onChange={(e) => setSelectedInvoice({ ...selectedInvoice, invoiceNo: e.target.value })}
                                                    placeholder="Enter"
                                                />
                                            </td>
                                            <th><strong>Invoice Date:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="date"
                                                    value={selectedInvoice?.invoiceDate || ""}
                                                    onChange={(e) =>
                                                        setSelectedInvoice({ ...selectedInvoice, invoiceDate: e.target.value })
                                                    }
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th><strong>PO No:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="text"
                                                    value={selectedInvoice?.poNo || ""}
                                                    onChange={(e) => setSelectedInvoice({ ...selectedInvoice, poNo: e.target.value })}
                                                    placeholder="Enter"
                                                />
                                            </td>
                                            <th><strong>DC No:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="text"
                                                    value={selectedInvoice?.deliveryChallanNumber || ""}
                                                    onChange={(e) =>
                                                        setSelectedInvoice({ ...selectedInvoice, deliveryChallanNumber: e.target.value })
                                                    }
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={4}>
                                                <div className="text-center mt-3 mb-2">
                                                    <strong>The Following Goods have been Received</strong>
                                                </div>
                                                <table className="table table-sm table-bordered mt-2">
                                                {/*<table className="table table-sm goods-table mt-2">*/}
                                                    <thead>
                                                        <tr>
                                                            <th>S. No.</th>
                                                            <th>Description of Material</th>
                                                            <th>Quantity</th>
                                                            <th>Unit</th>
                                                            <th>Remarks</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(selectedInvoice?.goodsList?.length > 0 ? selectedInvoice.goodsList : [{}]).map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>
                                                                    <Input
                                                                        type="text"
                                                                        value={item.description || ""}
                                                                        onChange={(e) => updateGoodsList(index, "description", e.target.value)}
                                                                        placeholder="Description"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Input
                                                                        type="number"
                                                                        value={item.quantity || ""}
                                                                        onChange={(e) => updateGoodsList(index, "quantity", e.target.value)}
                                                                        placeholder="Qty"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Input
                                                                        type="text"
                                                                        value={item.unit || ""}
                                                                        onChange={(e) => updateGoodsList(index, "unit", e.target.value)}
                                                                        placeholder="Unit"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Input
                                                                        type="text"
                                                                        value={item.remarks || ""}
                                                                        onChange={(e) => updateGoodsList(index, "remarks", e.target.value)}
                                                                        placeholder="Remarks"
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>                                            
                                            <th><strong>Received By:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="text"
                                                    value={selectedInvoice?.receivedBy || ""}
                                                    onChange={(e) => setSelectedInvoice({ ...selectedInvoice, receivedBy: e.target.value })}
                                                    placeholder="By"
                                                />
                                            </td>
                                            <th><strong>Prepared By:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="text"
                                                    value={selectedInvoice?.preparedBy || ""}
                                                    onChange={(e) => setSelectedInvoice({ ...selectedInvoice, preparedBy: e.target.value })}
                                                    placeholder="By"
                                                />
                                            </td>
                                        </tr>
                                        <tr>                                            
                                            <th><strong>Collected By:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="text"
                                                    value={selectedInvoice?.collectedBy || ""}
                                                    onChange={(e) => setSelectedInvoice({ ...selectedInvoice, collectedBy: e.target.value })}
                                                    placeholder="By"
                                                />
                                            </td>
                                            <th><strong>Handover To:</strong><span className="required-field">*</span></th>
                                            <td style={{ width: '30%' }}>
                                                <Input
                                                    type="text"
                                                    value={selectedInvoice?.handoverTo || ""}
                                                    onChange={(e) => setSelectedInvoice({ ...selectedInvoice, handoverTo: e.target.value })}
                                                    placeholder="To"
                                                />
                                            </td>
                                        </tr>                                      
                                        <tr>
                                            <th><strong>Approval Status:</strong><span className="required-field">*</span></th>
                                            <td>
                                                <select
                                                    className="form-control"
                                                    value={selectedInvoice?.approvalStatus || ""}
                                                    onChange={(e) => setSelectedInvoice({
                                                        ...selectedInvoice,
                                                        approvalStatus: e.target.value 
                                                    })}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="4">Approved</option>
                                                    <option value="3">Rejected</option>
                                                </select>
                                                {approvalStatusError && (
                                                    <div className="text-danger">{approvalStatusError}</div>
                                                )}                                                
                                            </td>
                                            <th><strong>Comments:</strong><span className="required-field">*</span></th>
                                            <td>
                                                <Input
                                                    type="textarea"
                                                    value={selectedInvoice?.comments || ""}
                                                    onChange={(e) => setSelectedInvoice({
                                                        ...selectedInvoice,
                                                        comments: e.target.value
                                                    })}
                                                    placeholder="Enter your comment..."
                                                />
                                            </td>
                                        </tr>
                                                                                                                    
                                    </tbody>
                                </Table>
                                <ModalFooter>
                                    <Button color="success" onClick={handleSaveStatus}>Save</Button>

                                    <Button color="danger" onClick={() => setShowModal(false)}>Close</Button>
                                </ModalFooter>
                            </>
                        )}
                      
                        {/*{activeTab === "info" && selectedInvoice && activeTab !== "details" && (*/}
                        {/*    <VendorInfoTabs*/}
                        {/*        selectedVendor={selectedInvoice}*/}
                        {/*        isEditing={isEditing}*/}
                        {/*        setIsEditing={setIsEditing}*/}
                        {/*        handleInputChange={handleInputChange}*/}
                        {/*        subTab={subTab}*/}
                        {/*        setSubTab={setSubTab}*/}
                        {/*        type="invoice"*/}
                        {/*    />*/}
                        {/*)}*/}


                        {/*{activeTab === "infoInvoice" && invoiceInfo && activeTab !== "details" && (*/}
                        {/*    <Table bordered className="info-table1">*/}
                        {/*        <tbody>*/}
                        {/*            <tr>*/}
                        {/*                <th><strong>Invoice No:</strong></th>*/}
                        {/*                <td>{invoiceInfo.invoiceNo || "N/A"}</td>*/}
                        {/*                <th><strong>Invoice Date:</strong></th>*/}
                        {/*                <td>{invoiceInfo.invoiceDate ? new Date(invoiceInfo.invoiceDate).toLocaleDateString("en-GB") : "N/A"}</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <th><strong>Vendor ID:</strong></th>*/}
                        {/*                <td>{invoiceInfo.vendoerid || "N/A"}</td>*/}
                        {/*                <th><strong>Invoice Type:</strong></th>*/}
                        {/*                <td>{invoiceInfo.invoiceType || "N/A"}</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <th><strong>PO No:</strong></th>*/}
                        {/*                <td>{invoiceInfo.pono || "N/A"}</td>*/}
                        {/*                <th><strong>Agreement No:</strong></th>*/}
                        {/*                <td>{invoiceInfo.agreementNo || "N/A"}</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <th><strong>Start Date:</strong></th>*/}
                        {/*                <td>{invoiceInfo.createdDate ? new Date(invoiceInfo.createdDate).toLocaleDateString("en-GB") : "N/A"}</td>*/}
                        {/*                <th><strong>End Date:</strong></th>*/}
                        {/*                <td>{invoiceInfo.endDate ? new Date(invoiceInfo.endDate).toLocaleDateString("en-GB") : "N/A"}</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <th><strong>Total Value:</strong></th>*/}
                        {/*                <td>₹{invoiceInfo.totalValue?.toFixed(2) || "0.00"}</td>*/}
                        {/*                <th><strong>CGST:</strong></th>*/}
                        {/*                <td>₹{invoiceInfo.cgst?.toFixed(2) || "0.00"}</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <th><strong>SGST:</strong></th>*/}
                        {/*                <td>₹{invoiceInfo.sgst?.toFixed(2) || "0.00"}</td>*/}
                        {/*                <th><strong>IGST:</strong></th>*/}
                        {/*                <td>₹{invoiceInfo.igst?.toFixed(2) || "0.00"}</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <th><strong>LOB:</strong></th>*/}
                        {/*                <td>{invoiceInfo.lob || "N/A"}</td>*/}
                        {/*                <th><strong>Description:</strong></th>*/}
                        {/*                <td>{invoiceInfo.description || "N/A"}</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <th><strong>PROB Name:</strong></th>*/}
                        {/*                <td>{invoiceInfo.probname || "N/A"}</td>*/}
                        {/*                <th><strong>MSPE:</strong></th>*/}
                        {/*                <td>{invoiceInfo.mspe || "N/A"}</td>*/}
                        {/*            </tr>*/}
                        {/*        </tbody>*/}
                        {/*    </Table>*/}
                        {/*)}*/}


                        {/*{activeTab === "history" && activeTab !== "details" && (*/}
                        {/*    <div className="history-container1">*/}

                        {/*        <table className="history-table1">*/}
                        {/*            <thead>*/}
                        {/*                <tr>*/}
                        {/*                    <th>#</th>*/}
                        {/*                    <th>Approval Status</th>*/}
                        {/*                    <th>Approver Name</th>*/}
                        {/*                    <th>Date</th>*/}
                        {/*                    <th>Comments</th>*/}
                        {/*                </tr>*/}
                        {/*            </thead>*/}
                        {/*            <tbody>*/}
                        {/*                {historyData.length > 0 ? (*/}
                        {/*                    historyData.map((item, index) => (*/}
                        {/*                        <tr key={index}>*/}
                        {/*                            <td>{index + 1}</td>*/}
                        {/*                            <td>{item.approvalStatus || "N/A"}</td> */}{/* lowercase */}
                        {/*                            <td>{item.approvalname || "N/A"}</td>*/}
                        {/*                            <td>*/}
                        {/*                                {item.createdate*/}
                        {/*                                    ? new Date(item.createdate).toLocaleDateString("en-GB")*/}
                        {/*                                    : "N/A"}*/}
                        {/*                            </td>*/}
                        {/*                            <td>{item.comments || "N/A"}</td>*/}
                        {/*                        </tr>*/}
                        {/*                    ))*/}
                        {/*                ) : (*/}
                        {/*                    <tr>*/}
                        {/*                        <td colSpan="5" className="text-center">No history found</td>*/}
                        {/*                    </tr>*/}
                        {/*                )}*/}
                        {/*            </tbody>*/}
                        {/*        </table>*/}
                        {/*    </div>*/}
                        {/*)}*/}

                    </ModalBody>
                    {/*<ModalFooter>*/}
                    {/*    <Button color="primary" onClick={handleSaveStatus}>Save</Button>*/}

                    {/*    <Button color="secondary" onClick={() => setShowModal(false)}>Close</Button>*/}
                    {/*</ModalFooter>*/}
                </Modal>

        </DashboardLayout>
    );
};

export default ViewAllInvoicesSecurity;
